import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "antd";

function LogoutButton() {
  const { isAuthenticated, logout } = useAuth0();

  return (
    isAuthenticated && (
      <Button
        alt={"logout"}
        size={"large"}
        type={"primary"}
        onClick={() => {
          logout({
            logoutParams: {
              returnTo: window.location.origin,
            },
          });
        }}
      >
        Logout
      </Button>
    )
  );
}

export default LogoutButton;
